import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverTrigger,
  Text,
  useDisclosure,
} from '@chakra-ui/core';
import { RiDeleteBin5Fill, RiEdit2Fill } from 'react-icons/ri';
import React, { useState } from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { useTranslation } from 'react-i18next';
import colors from '../../../../styles/colors';
import { FreeFormQuestion } from '../PositionType';

export type SortableFreeFormQuestionItemType = {
  que: FreeFormQuestion;
  itemIndex: number;
  editFreeFormQuestion: (index: number, item: FreeFormQuestion) => void;
  deleteFreeFormQuestion: (index: number) => void;
};

export const SortableFreeFormQuestionItem = SortableElement(
  ({ que, itemIndex, editFreeFormQuestion, deleteFreeFormQuestion }: SortableFreeFormQuestionItemType) => {
    const { t } = useTranslation();
    const { onClose } = useDisclosure();
    const { onOpen: onOpenFreeForm, onClose: onCloseFreeForm, isOpen: isOpenFreeForm } = useDisclosure();
    const [deleteIndexFreeForm, setdeleteIndexFreeForm] = useState<number | null>(null);

    return (
      <li style={{ zIndex: 9999, cursor: 'move', marginTop: '15px', listStyle: 'none' }}>
        <Flex key={itemIndex} alignItems="center" justifyContent="space-between">
          <Text>{que.text}</Text>
          <Flex>
            <IconButton
              backgroundColor={colors.gray[50]}
              aria-label="Edit Question"
              icon={<RiEdit2Fill style={{ color: colors.blue[500] }} />}
              data-testid={`EditQuestionFreeFormBtn-${itemIndex}`}
              onClick={() => {
                editFreeFormQuestion(itemIndex, que);
              }}
            />
            <Box>
              <Popover
                returnFocusOnClose={false}
                isOpen={isOpenFreeForm && deleteIndexFreeForm === itemIndex}
                onClose={onCloseFreeForm}
                closeOnBlur
                isLazy
              >
                <PopoverTrigger>
                  <IconButton
                    backgroundColor={colors.gray[50]}
                    ml={3}
                    aria-label="Delete Question"
                    icon={<RiDeleteBin5Fill style={{ color: colors.blue[500] }} />}
                    data-testid={`DeleteQuestionFreeFormBtn-${itemIndex}`}
                    onClick={() => {
                      onOpenFreeForm();
                      setdeleteIndexFreeForm(itemIndex);
                    }}
                  />
                </PopoverTrigger>
                {isOpenFreeForm && (
                  <PopoverContent rootProps={{ style: { right: 0 } }}>
                    <PopoverBody fontWeight="semibold">{t('createJobPosition:deleteQuestionConfirmation')}</PopoverBody>
                    <PopoverArrow />
                    <PopoverCloseButton />
                    <PopoverFooter d="flex" justifyContent="flex-end">
                      <ButtonGroup size="sm">
                        <Button variant="outline" onClick={onClose}>
                          {t('common:questions.answerNegative')}
                        </Button>
                        <Button
                          colorScheme="red"
                          onClick={() => {
                            deleteFreeFormQuestion(itemIndex);
                            onCloseFreeForm();
                          }}
                          data-testid={`deleteQuestionConfirmFreeFormBtn-${itemIndex}`}
                        >
                          {t('common:questions.answerPositive')}
                        </Button>
                      </ButtonGroup>
                    </PopoverFooter>
                  </PopoverContent>
                )}
              </Popover>
            </Box>
          </Flex>
        </Flex>
      </li>
    );
  },
);
